import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

import ListingCard from "@/components/ListingCard";
import { browseApi } from "@/api/browse";
import { logger } from "@/utils/logger";

const Browse = () => {
  const { species: routeSpecies } = useParams();
  const species = routeSpecies || "all";
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    fetchListings();
  }, [species]);

  const fetchListings = async () => {
    setLoading(true);
    try {
      const data = species === "all"
        ? await browseApi.search()
        : await browseApi.browse(species);
      setListings(data.listings);
      setTotal(data.total);
    } catch (error) {
      logger.error("Failed to fetch listings:", error);
    } finally {
      setLoading(false);
    }
  };

  const displayNames = {
    all: "All Listings",
    equine: "Equine",
    canine: "Canine",
    feline: "Feline",
    cattle: "Cattle",
    exotics: "Exotics",
    others: "Farm Animals"
  };
  const displayName = displayNames[species] || species.charAt(0).toUpperCase() + species.slice(1);

  return (
    <div className="pt-24 pb-16 px-6 md:px-12 min-h-screen bg-[#050505]">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-2">Browse</p>
          <h1 className="text-4xl md:text-5xl text-[#EDEDED] mb-2">{displayName}</h1>
          <p className="text-[#A1A1AA]">{total} listings available</p>
        </div>

        {loading ? (
          <div className="flex justify-center py-20">
            <Loader2 className="w-8 h-8 text-[#D4AF37] animate-spin" />
          </div>
        ) : listings.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-[#A1A1AA] text-lg mb-4">No listings found for {displayName}</p>
            <Link to="/" className="btn-secondary text-sm">Back to Home</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {listings.map((listing) => (
              <ListingCard key={listing.listing_id} listing={listing} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Browse;
